module.exports = __webpack_public_path__ + "static/img/fullscreen-image_consulting-services_600.ed1b260.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/consulting/fullscreen-image_consulting-services_600.png
// module id = QW5u
// module chunks = 0